import {useThemeContext} from '../../../context';
import {Accordion, Nav} from 'react-bootstrap';
import {SUB_NAV_LIST} from './subNavData';
import Icon from '../../../assets/icons';

const HamburgerItem = ({hamburgerIcon, hamburgerTitle, eventKey, subRoute}) => {
    const {theme} = useThemeContext();

    return (
        <Nav.Item>
            <Nav.Link eventKey={eventKey}>
                <span>
                    <Icon name={hamburgerIcon} viewBox={'0 0 18 18'} fill={'white'} height={'20'} width={'20'} />
                </span>

                <span className="fontSize14 marLeft20" style={{color: theme.white}}>
                    {hamburgerTitle}
                </span>
            </Nav.Link>

            {subRoute && SUB_NAV_LIST[subRoute] ? (
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        {SUB_NAV_LIST[subRoute].map((item, index) => {
                            return (
                                <Accordion.Body key={index}>
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey={item.route}
                                            style={{
                                                textDecoration: 'none',
                                                color: '#ffff',
                                                padding: '0px',
                                            }}>
                                            {item.name}
                                        </Nav.Link>
                                    </Nav.Item>
                                </Accordion.Body>
                            );
                        })}
                    </Accordion.Item>
                </Accordion>
            ) : null}
        </Nav.Item>
    );
};

export default HamburgerItem;
